export class ConsoleLogger {
    error(message) {
        console.error(message);
    }
    warn(message) {
        console.warn(message);
    }
    info(message) {
        console.info(message);
    }
    log(message) {
        console.log(message);
    }
    debug(message) {
        console.debug(message);
    }
}
//# sourceMappingURL=logger.js.map